import { render, staticRenderFns } from "./AngelRegistration.vue?vue&type=template&id=2b9d5d65&scoped=true&"
import script from "./AngelRegistration.vue?vue&type=script&lang=js&"
export * from "./AngelRegistration.vue?vue&type=script&lang=js&"
import style0 from "./AngelRegistration.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AngelRegistration.vue?vue&type=style&index=1&id=2b9d5d65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9d5d65",
  null
  
)

export default component.exports